import {createEntityAdapter, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {mapValues} from 'lodash';
import {AuthEntity} from '~/redux/auth/types';
import {RootState} from '~/redux/root-reducer';
import {ReducerState} from '~/utils/thunk-api/type';
import {DEFAULT_SOURCE_REDUCER_STATE} from '~/utils/thunk-api/constants';
import {SOURCES_AUTH} from '~/redux/auth/entity-config';
import {AdminEntity} from '~/redux/admins/types';
import {loginByEmail} from '~/redux/auth/thunk';
import {fetchSuccess} from '~/utils/thunk-api';
import {fetchCurrentUserInfo} from '~/redux/admins/thunk';

/* Slice */
interface InitialState extends ReducerState {
  currentUser?: AdminEntity;
  token?: string;
}

const sources = mapValues(SOURCES_AUTH, () => DEFAULT_SOURCE_REDUCER_STATE);

const authsAdapter = createEntityAdapter<AuthEntity>();

const initialState = authsAdapter.getInitialState<InitialState>({
  sources,
  currentUser: {} as AdminEntity,
  token: undefined,
});

// Slice
const auths = createSlice({
  name: 'auths',
  initialState,
  reducers: {
    setCurrentUser(state, {payload}: PayloadAction<AuthEntity>) {
      if (payload.user) {
        state.currentUser = {...state.currentUser, ...payload.user};
      }
      state.token = payload.token;
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchCurrentUserInfo.fulfilled, (state, {payload}) => {
      const {normalized} = payload;
      state.currentUser = {...state.currentUser, ...normalized.entities.admins[normalized.result]};
      fetchSuccess(state, payload);
    });
    builder.addCase(loginByEmail.fulfilled, (state, {payload}) => {
      const {normalized} = payload;
      state.currentUser = normalized.entities.auths[normalized.result].user;
    });
  },
});

export const {setCurrentUser} = auths.actions;

export default auths.reducer;

export const {
  selectById: selectAuthById,
  selectIds: selectAuthsIds,
  selectEntities: selectAuthsEntities,
  selectAll: selectAllAuths,
  selectTotal: selectTotalAuths,
} = authsAdapter.getSelectors((state: RootState) => state.auth);
